import { render, staticRenderFns } from "./PayrollResource.vue?vue&type=template&id=7ef4fa4c&"
import script from "./PayrollResource.vue?vue&type=script&lang=js&"
export * from "./PayrollResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports